import { createFileRoute } from "@tanstack/react-router";
import { PlansPage } from "@/features/portalstore/PlansPage";

/** Portal strategy plans, one card per client project (P109). */
export const Route = createFileRoute("/portal/plans")({
  component: PlansPage,
});
